<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top: 20px">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="batchName" placeholder="请输入批次名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getCertificateBatchList()">搜索</el-button>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo()">新增</el-button>
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left: 30px">
            <el-table :data="list">
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="batchName" label="批次名称"></el-table-column>
                <el-table-column prop="startDate" label="申请开始时间"></el-table-column>
                <el-table-column prop="endDate" label="申请结束时间"></el-table-column>
                <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-page-con">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="onPageChangeHandler"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    v-show="totalCount > 0"
                    style="text-align: center"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :title="titleFormVisible" :visible.sync="dialogFormVisible" :append-to-body="true" width="800px">
            <el-form :model="from" class="demo-form-inline" label-width="120px">
                <el-form-item label="批次名称">
                    <el-input v-model="from.batchName"></el-input>
                </el-form-item>
                <el-form-item label="申请开始时间">
                    <el-date-picker
                        v-model="from.startDate"
                        type="datetime"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="申请结束时间">
                    <el-date-picker
                        v-model="from.endDate"
                        type="datetime"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            batchName: "",
            titleFormVisible:"",
            dialogFormVisible:false,
            list: [],
            from: {
                id: "",
                batchName: "",
                startDate: "",
                endDate: ""
            }
        };
    },
    components: {
    },
    created() {
        this.getCertificateBatchList();
    },
    watch: {
       
    },
    methods: {
        addInfo() {
            this.from.id = "";
            this.from.batchName = "";
            this.from.startDate = "";
            this.from.endDate = "";
            this.titleFormVisible = "新增";
            this.dialogFormVisible = true;
        },
        //添加、编辑
        editInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateBatchMag/addOrEditCertificateBatch", {
                    id: this.from.id,
                    batchName: this.from.batchName,
                    startDate: this.from.startDate,
                    endDate: this.from.endDate
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getCertificateBatchList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.from.id = "";
            this.from.batchName = "";
            this.from.startDate = "";
            this.from.endDate = "";
            this.dialogFormVisible = false;
        },
        //弹出框赋值
        handleEdit(row) {
            this.from.id = row.id;
            this.from.batchName = row.batchName;
            this.from.startDate = row.startDate;
            this.from.endDate = row.endDate;
            this.titleFormVisible = "编辑";
            this.dialogFormVisible = true;
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ItcCertificateBatchMag/deleteBatchs", {
                        ids: id,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getCertificateBatchList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //查询
        getCertificateBatchList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateBatchMag/getCertificateBatchList", {
                    batchName: this.batchName,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCertificateBatchList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getCertificateBatchList();
        },
    },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2f7dff;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1a2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #d8e0e6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #e65b72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #ee6c3a;
        border-color: #ee6c3a;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
